import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import SelectedImageDisplay from "../classic/SelectedImageDisplay";
import ThumbnailGallery from "../classic/ThumbnailGallery";
import TitleBar from "./TitleBar";

export default function EmbiggenerContents({
  selectedImage, callbacks, images = [], productGroup, handleClose, ...props
}) {

  // prevent the screen fading overlay from seeing this
  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  return <div onClick={handleClick}
    className="relative h-full container mx-auto bg-paper border-4">
    <TitleBar productGroup={productGroup} handleClose={handleClose}/>
    <div className="p-2 w-full h-full overflow-y-hidden pb-16">
      <div className="grid h-full lg:grid-cols-4 gap-2 overflow-y-hidden">
        <div className="lg:col-span-3">
          <SelectedImageDisplay
            embiggened={true}
            inPopup={true}
            productGroup={productGroup}
            callbacks={callbacks}
            selectedImage={selectedImage}/>

            <div className="text-center text-lg pt-8">
              <a className="inline-block px-2 py-1 btn-outline-dark"
                onClick={handleClose}>Close</a>
            </div>
        </div>
        <div className="lg:px-4 overflow-y-scroll">
          <ThumbnailGallery
            selectedImage={selectedImage}
            images={images}
            productGroup={productGroup}
            callbacks={callbacks}/>
        </div>
      </div>
    </div>
  </div>
}
